<template>
  <div>
    <div class="banner">
      <div>
        <span>{{$t('home.s5_1')}}</span>
        <p class="pc" v-html="$t('home.s5_2')"></p>
        <p class="mobile" v-html="$t('home.s5_3')"></p>
      </div>

    </div>
    <div class="section-wrap ">
      <div class="c-999 program-label">
        <span @click="routerSkip('/')">{{$t('header.nav1')}}</span>  >   <span class="c-666">{{$t('sales.nav')}}</span>
      </div>
    </div>
    <div class="b-fff map">
      <div class="section-wrap ">
        <img src="@/assets/images/sales/map.png" class="w100 block pc" v-if="$t('language.name') != 'English'"/>
        <img src="@/assets/images/sales/map1.png" class="w100 block pc"  v-if="$t('language.name') == 'English'"/>
        <img src="@/assets/images/sales/map.png" class="w100 block mobile" v-if="$t('language.name') != 'English'"/>
        <img src="@/assets/images/sales/map1.png" class="w100 block mobile"  v-if="$t('language.name') == 'English'"/>
<!--        <p class="mobile  c-666">-->
<!--        <span v-for="(item,index) in country">{{item}}<span v-if="index != (country.length -1) ">/</span> </span>-->
<!--        </p>-->
      </div>
    </div>


  </div>
</template>

<script>

  export default {
    name: 'sales',
    data () {
      return {
        country:this.$t('home.s5_4')

      }
    },
    created () {
      this.getList()
    },
    methods: {
      getList() {

      }
    }
  }
</script>
<style lang="stylus" scoped>
  @import "~@/assets/css/public.styl"

  .English{
    .map span{display:inline-block;font-size:.22rem}

  }
  .realize-more
    user-select none;cursor pointer
  h2,h3,h4,h5,h6,p{
    margin: 0
  }

  .banner{height:280px;background :url("~@/assets/images/sales/banner.jpg") no-repeat center/auto 100%;
  p{font-size:.16rem;    padding-top: .08rem;}
  }
  .map{margin-bottom:1.12rem;}
  @media screen and (max-width: 768px){
    .English {
      .banner p{font-size:.2rem}
    }
    .section-wrap{padding:0;}
    .banner{height:3.75rem;background :url("~@/assets/images/sales/m-banner.jpg") no-repeat center/cover;
    p{font-size:.26rem;padding-top: .2rem;}}

  .map {margin-bottom:.25rem;
    p{font-size :.26rem;line-height:.44rem;padding:0 .33rem;    padding-bottom: .75rem;
      span{margin:0 .2em;
        span {
          margin-right: 0
        }} }
  }
  }
</style>
<style >
  body{background :#f8f8f8}
  </style>
